import fireplace from "./fireplace.jsx";
import portal from "./portal.jsx";
import tree from "./tree.jsx";
import door from "./door.jsx";

export default {
  fireplace,
  portal,
  tree,
  door,
};
